import { useCallback } from 'react';

import { appStore } from '@kaltura-ott/tvpil-shared';

import { AutoRetryFuncProps } from 'context/error/types';

interface Props {
  setIsPendingRetry: (value: React.SetStateAction<boolean>) => void;
  clearError: () => void;
}

export const useAutoRetry = ({ setIsPendingRetry, clearError }: Props) => {
  return useCallback(
    async ({ autoRetryCallback, isTvpilError }: AutoRetryFuncProps) => {
      if (autoRetryCallback) {
        setIsPendingRetry(true);
        await autoRetryCallback();

        if (!appStore.apiError && isTvpilError) {
          clearError();
        }
      }
    },
    [clearError],
  );
};
